import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { CustomerForm } from "../page/customerEdit";

export let popup: (customerId?: string) => void;

const CreateUserModal = ({
	defaultShow = false
}: {
	defaultShow?: boolean;
}) => {
	const [show, setShow] = useState(defaultShow);
	const [customerId, setCustomerId] = useState("");

	useEffect(() => {
		popup = (customerId?: string) => {
			setShow(true);
			setCustomerId(customerId || "");
		};
	}, []);

	const handleClose = () => setShow(false);

	return (
		<>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Tạo Khách Hàng</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<CustomerForm customerId={customerId} shouldRedirect={false} />
				</Modal.Body>
			</Modal>
		</>
	);
};

export default CreateUserModal;
